var render = function render(){var _vm=this,_c=_vm._self._c;return _c('school-lookup',{on:{"selectSchool":_vm.goToSchool}})
}
var staticRenderFns = []

export { render, staticRenderFns }